import { SxStyleProp } from 'theme-ui';

export const ShareIcon: SxStyleProp = {
  marginX: '22px',
};

export const IconBox: SxStyleProp = {
  justifyContent: 'center',
  marginTop: '19px',
};

export const ShareTitle: SxStyleProp = {
  textAlign: 'center',
};

export const iconContainer: SxStyleProp = {
  outline: 'none !important',
};
